import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { routes } from 'routes';

export const useNavigateToCommunityDetail = () => {
  const { push } = useHistory();

  return useCallback(
    (id: string) => {
      push(routes.community.feed(id));
    },
    [push],
  );
};
